<template>
    <div class="noticeBell">
        <div class="icon-bell" @mouseover="iconOverFn" @mouseleave="noticeShow && iconleaveFn($event)">
            <el-badge :value="total==0?'':total">
                <span class="el-icon-message-solid"></span>
            </el-badge>
        </div>
        <div class="notice-list" v-show="noticeList" @mouseover="contentOver" @mouseleave="contentLeave($event)">
            <div class="tit">
                我的待办<span>{{ total }}</span>
                <span class="iconfont icon-shanchuinlingdang  noticeListClose" @click="noticeListClose"></span>
            </div>
            <div v-if="voteTable && voteTable.length > 0" class="notice-wrap">
                <div v-for="(item,i) in voteTable" class="notice-item">
                    <div class="notice-index">{{ i + 1}}</div>
                    <div class="notice-content" >
                        <p  @click="toCorrectDetail(item.serialNumber)">{{item.title}}</p>
                        <p>
                            <span>{{item.type}}模块</span>
                            <span>{{item.time}}</span>
                        </p>
                    </div>
                    <div class="notice-status">
                        <span>待办</span>
                    </div>
                </div>
            </div>
            <div class="notice-wrap noData" v-if="voteTable && voteTable.length == 0">暂无数据</div>
            <div class="page-footer">
                <el-pagination @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="form.pageIndex"
                    :page-sizes="[10,20]"
                    :page-size="form.pageSize"
                    layout="total, prev, pager, next"
                    :total="total">
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>

    import { EventSourcePolyfill } from 'event-source-polyfill'
    import services from "../services/common.service";
    import config from "../app.config";
    export default {
        name: "noticeBell",
        data(){
            return{
                voteTable:[],
                noticeList:false,
                loading:true,
                form:{
                    pageIndex:1,
                    pageSize:10,
                },
                noticeShow:false,

                total:0,
                sseSossurce:null
            }
        },
        // watch:{
        //     voteTable:{
        //         handler(newval,oldval){
        //             console.log('watch========')
        //             let _this = this
        //             if(newval){
        //                 console.log(newval)
        //                 // _this.voteTable = [...newval]
        //                 _this.total = newval.length
        //             }
        //         },
        //         // immediate:true
        //     }
        // },
        created(){
            // console.log('created')
            if(this.$cookies.get('user_name') !==null && this.$cookies.get('user_name') !== undefined){
                this.sseEvent()
            }

            // this.request();
            window.addEventListener("error", (event) => {
                console.log('windwerror')
                console.log(event)
            })
            // 10秒刷新一次我的待办
            // this.$interval(() => {
            //     this.request()
            // },10000);
        },
        mounted() {
            let _this = this
            // setTimeout(function() {
            //     _this.getAngencyUncompleted()
            // }, 500);
            this.getAngencyUncompleted()

            // this.$nextTick(function(){
            //     this.getAngencyUncompleted()
            // })


        },
        computed:{
            username:function () {
                return this.$store.state.userInfo.user.username
            },
        },
        methods:{
            sseEvent_1(){
                let sseurl = `${config.sseurl}?channel=wedof_itsm_${this.$cookies.get('user_name')}`
                const _this = this
                this.sseSossurce = new EventSourcePolyfill(sseurl, {
                    heartbeatTimeout:5000, //超时时间，毫秒为单位，以5分钟为例300000
                    // headers: {
                    //     '请求头名称': '请求头值'
                    // }
                });
                console.log(this.sseSossurce)
                this.sseSossurce.onopen = function (e) {
                    console.log('onopen', e);
                };
                this.sseSossurce.addEventListener("agency_order", function(event) {
                    const val = JSON.parse(event.data);
                    console.log('待办工单')
                    _this.voteTable = [val, ..._this.voteTable]
                    _this.total++
                    _this.$store.commit('setMyAgencyData', _this.voteTable)
                })
                //移除待办工单
                this.sseSossurce.addEventListener("remove_agency_order", function(event) {
                    const val = JSON.parse(event.data);
                    console.log('移除待办工单')
                    // console.log(val.serialNumber)
                    let newArray = _this.voteTable.filter(item=>item.serialNumber !== val.serialNumber)
                    // console.log(newArray)
                    _this.voteTable = [...newArray]
                    _this.total--
                    _this.$store.commit('setMyAgencyData', _this.voteTable)
                })

                // new Promise(resolve ,re)
                this.sseSossurce.onerror = function (e) {
                    console.log('onerror', e);
                    console.log(e.target.readyState)
                    window.onerror=function(message){
                        console.log(message)
                        return true
                    }
                    console.log(EventSource.CLOSED)
                    console.log(EventSource.CONNECTING)
                    console.log(_this.$cookies.get('user_name'))
                    // if(_this.$cookies.get('user_name') !==null && _this.$cookies.get('user_name') !== undefined){
                    //     _this.sseEvent_1()
                    // }
                    if(e.status == "504" || e.status == "502"){
                        if(_this.$cookies.get('user_name')){
                            _this.sseEvent_1()
                        }
                        // _this.sseEvent_1()
                    }
                }
            },

            sseEvent(){
                let _this = this
                if('EventSource' in window){
                    let sseurl = `${config.sseurl}?channel=wedof_itsm_${this.$cookies.get('user_name')}`
                    // console.log(sseurl)
                    this.sseSossurce = new EventSource(sseurl)
                    this.sseSossurce.onopen = function(e){
                        console.log('连接打开')
                        console.log(e)
                        // _this.getAngencyUncompleted()
                    }
                    //全部我的待办未办工单
                    // this.sseSossurce.addEventListener("my_agency_uncompleted", function(event) {
                    //     console.log('uncompleted')
                    //     const val = JSON.parse(event.data);
                    //     console.log('全部我的待办未办工单bell')
                    //     _this.$store.commit('setMyAgencyData', val.list)
                    //     _this.voteTable = [...val.list]
                    //     _this.total = val.list.length
                    // })
                    // 待办工单
                    this.sseSossurce.addEventListener("agency_order", function(event) {
                        const val = JSON.parse(event.data);
                        console.log('待办工单')
                        _this.voteTable = [val, ..._this.voteTable]
                        _this.total++
                        _this.$store.commit('setMyAgencyData', _this.voteTable)
                    })
                    //移除待办工单
                    this.sseSossurce.addEventListener("remove_agency_order", function(event) {
                        const val = JSON.parse(event.data);
                        console.log('移除待办工单')
                        // console.log(val.serialNumber)
                        let newArray = _this.voteTable.filter(item=>item.serialNumber !== val.serialNumber)
                        // console.log(newArray)
                        _this.voteTable = [...newArray]
                        _this.total--
                        _this.$store.commit('setMyAgencyData', _this.voteTable)
                    })


                    //对服务端断开链接的监听
                    this.sseSossurce.onerror = function(e){
                        console.log('onerror------------')
                        console.log(e)
                        window.addEventListener("error", (event) => {
                            console.log('windwerror')
                            console.log(event)
                        })
                        if(e.currentTarget.readyState == EventSource.CLOSED){
                            console.log('连接关闭')
                            if(_this.$cookies.get('user_name') !== null && _this.$cookies.get('user_name') !== undefined){
                                _this.sseEvent()
                            }
                        }else{
                            console.log('onerror:'+e.currentTarget.readyState)

                        }
                    }

                }else{
                    console.log('浏览器不支持sse')
                }
            },
            getAngencyUncompleted(){
                services.getMyAgencyUncompleted().then(res => {
                    console.log('')
                    this.$store.commit('setMyAgencyData', res.list)
                    this.voteTable = [...res.list]
                    this.total = res.list.length
                }).catch(err => {
                    this.$message.error(err.message);
                })

            },
            request(){
                let params = {
                    user:this.username,
                    complete:"0",
                    pageIndex:this.form.pageIndex,
                    pageSize:this.form.pageSize,
                };
                services.getMyAgencyList(params).then(res => {
                    this.voteTable = res.list;
                    this.total = res.total;
                }).catch(err => {
                    this.$message.error(err.message);
                }).finally(() => {
                    this.loading = false;
                })
            },
            //点击待办或请求中列表名称时跳转对应详情
            toCorrectDetail(val){
                let sn=val
                if (sn.indexOf('Eve')>-1) {
                    this.$router.push({path:'/eventDetail',query:{serialNumber:sn}})
                }
                if (sn.indexOf('Cha')>-1){
                    this.$router.push({path:'/changeDetail',query:{serialNumber:sn}})
                }
                if (sn.indexOf('Dep')>-1){
                    this.$router.push({path:'/deployDetail',query:{serialNumber:sn}})
                }
                if (sn.indexOf('Pro')>-1){
                    this.$router.push({path:'/problemDetail',query:{serialNumber:sn}})
                }
                if (sn.indexOf('Res')>-1){
                    this.$router.push({path:'/resourceApplyDetail',query:{serialNumber:sn}})
                }
            },
            iconOverFn(){
                this.noticeList=true
            },
            iconleaveFn(e){
                if(!e.relatedTarget)return;
                let vm = this;
                this.$timeout(() => {
                    vm.noticeList = false;
                },1000)
            },
            noticeListClose(){
                this.noticeList = false;
            },
            contentOver(){
                this.noticeShow = false;
            },
            contentLeave(e){
                if(!e.relatedTarget)return;
                let vm = this;
                vm.noticeList = false;
            },
            handleSizeChange(val){
                let pages = Math.ceil(this.total / val);
                this.form.pageSize = val;
                if(this.form.pageIndex > pages ){
                    this.form.pageIndex  = 1;
                };
                this.request()
            },
            handleCurrentChange(val){
                this.form.pageIndex = val;
                this.request();
            },
        },
        beforeDestroy() {
            if(this.sseSossurce){
                this.sseSossurce.close()
            }
        },
    }
</script>

<style lang="scss" scoped rel="stylesheet/scss">
    .noticeBell{
        position: relative;
    }
    .icon-bell{;
        span{
            font-size:20px;
        }
    }
    .notice-list{
        position: absolute;
        top: 26px;
        right: -1px;
        width: 361px;
        height: 500px;
        background-color: #ffffff;
        box-shadow: 0 2px 13px 0 #EAEAEA;
        border-radius:6px;
        display: flex;
        flex-direction: column;
        .tit{
            line-height: 48px;
            font-size: 14px;
            text-align: center;
            border-bottom: 1px solid #E9EAF1;
            span{
                padding-left: 15px;
            }
            span:nth-child(2){
                color: #3A8DFC;
                position: relative;
                left: 90px;
                &:hover{
                    color: #000;
                }
            }
        }
        .notice-wrap{
            flex:1;
            overflow-y: auto;
            .notice-item{
                border-bottom:1px solid #E9EAF1;
                display: flex;
                /*height: 60px;*/
                align-items: center;
                padding:0 10px;
                &:hover{
                    background-color: #F0F5FF;
                }
            }
            .notice-index{
                width:40px;
                color: #718295;
            }
            .notice-content{
                flex:1;
                p:nth-child(1){
                    width: 243px;
                    color: #1890ff;
                    /*overflow: hidden;*/
                    /*text-overflow:ellipsis;*/
                    white-space: normal;
                    cursor: pointer;
                    margin: 6px 0;
                }
                p:nth-child(2){
                    margin-bottom: 6px;
                    span{
                        font-size: 12px;
                        margin-right: 10px;
                    }
                }
            }
            .notice-status{
                width:50px;
                span{
                    padding:5px 8px;
                    background-color: #F0F5FF;
                    border-radius: 20px;
                    font-size:12px;
                    color: #718295;
                }
            }
        }
        .page-footer{
            height: 50px;
            border-top: 1px solid #E9EAF1;
            .el-pagination{
                margin:5px 0;
            }
        }
    }

</style>
